import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Outlet, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {Breadcrumb, Button, Card, Descriptions, Divider, Skeleton, Space, Table,} from "antd";
import moment from "moment";
import DrawerTradePoint from "../../dictionary/trade-point/trade-point/drawer_trade_point";
import {TradePointModel} from "../../../model/trade_point_model";
import DB_Payments from "../../../database/mobile/db_payments";
import BackButton from "../../tech/back_button";

const Payment = () => {
    const {payment_id} = useParams()
    const {token, user, defaultPageSize, setToken} = useContext(Context)
    const {getPayment} = DB_Payments(token)
    const {t} = useTranslation()
    const {errorConnect} = ModalWindow()
    const navigate = useNavigate()
    const controller = new AbortController()
    const [wait, setWait] = useState(false)
    const [openDrawerTradePoint, setOpenDrawerTradePoint] = useState(false)

    // const [pagination, setPagination] = useState({
    //     //current: 1,
    //     pageSize: defaultPageSize,
    //     //total:200
    // })

    let [data, setData] = useState({
        trade_point: TradePointModel,
        payments: []
    })

    const columns = [
        {
            title: t('date'),
            dataIndex: 'date',
            render: (date) => moment.utc(date).format("DD.MM.YYYY HH:mm")
        },
        {
            title: <> {t('invoice_number_date')}<br/>{t('invoice_number')} </>,
            dataIndex: 'invoice_number',
            render: (invoice_number, record) =>
                <>
                    {record.invoice_number_date? moment(record.invoice_number_date).format("DD.MM.YYYY") : null}
                    <br/>
                    {invoice_number}
                </>
        },

        {
            title: t('org_structure'),
            dataIndex: 'org_structure',
        },
        {
            title: t('repay'),
            dataIndex: 'repay',
        },
    ]

    useEffect(() => {
        window.scroll(0, 0)
        if (wait) {
            controller.abort()
        }
        setWait(true)
        if (payment_id != null) {
            getPayment(controller, payment_id)
                .then(res => {
                    setData(res.data)
                    setWait(false);
                })
                .catch((e) => {
                    if (!axios.isCancel(e)) {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    }
                })
        }
    }, [])

const back = () => {
 navigate(-1)
}

    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('payments')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        {/*<Link key='1' to={from ? from :*/}
                        {/*    path ? `/mobile_app/payments?${path}` : "/mobile_app/payments"}>*/}
                        {/*    <Button type={'default'} shape={'round'} onClick={back}>{t('back')}</Button>*/}
                        <BackButton/>
                        {/*</Link>*/}
                    </Space>
                </Space>
                <Card
                    // title={<>{t('ID')} <br/> {payment_id}</>} extra={<TagStatusOrder record={order}/>}
                >
                    <Skeleton loading={wait} active>
                        <Descriptions>

                            {/*<Descriptions.Item label={t('date_create')} span={1}>*/}
                            {/*    <span style={{fontFamily: 'Montserrat-Medium'}}>{moment.utc(data.payments.date).format("DD.MM.YYYY")}</span>*/}
                            {/*</Descriptions.Item>*/}


                            <Descriptions.Item label={t('trade_point')} span={2} >
                                <Button type={'link'} style={{height:'auto', padding:'0'}} onClick={e => setOpenDrawerTradePoint(true)}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}} >{data.trade_point.name}</span>
                                </Button>
                            </Descriptions.Item>

                        </Descriptions>
                    </Skeleton>
                    <Divider/>

                    <Table
                        style={{'--cursor': "auto" }}
                        columns={columns}
                        dataSource={data.payments}
                        rowKey="id"
                        loading={wait}
                        pagination={false}
                        size={"small"}
                    />

                </Card>
            </div>
            <Outlet/>

            <DrawerTradePoint
                trade_point={data.trade_point}
                show={openDrawerTradePoint}
                setShow={setOpenDrawerTradePoint}/>
        </>
    )
}

export default Payment